import { render, staticRenderFns } from "./PreviewStencilFile.vue?vue&type=template&id=0fbda45d&scoped=true&"
import script from "./PreviewStencilFile.vue?vue&type=script&lang=ts&"
export * from "./PreviewStencilFile.vue?vue&type=script&lang=ts&"
import style0 from "./PreviewStencilFile.vue?vue&type=style&index=0&id=0fbda45d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbda45d",
  null
  
)

export default component.exports